import type {DateRange, Matcher} from 'react-day-picker';
import {isDayBlocked} from './isDayBlocked';
import type {DateInput} from './dateUtils';

type CreateDisabledMatchersProps = {
  disabledDays?: Matcher | Matcher[];
  minDate?: DateInput;
  maxDate?: DateInput;
  maxDays?: number;
  minDays?: number;
  datesRange?: DateRange;
};

export const createDisabledMatchers = ({
  disabledDays,
  minDate,
  maxDate,
  maxDays,
  minDays,
  datesRange,
}: CreateDisabledMatchersProps): Matcher[] => {
  const result: Matcher[] = [
    isDayBlocked({minDate, maxDate, maxDays, minDays, datesRange}),
  ];

  if (Array.isArray(disabledDays)) result.push(...disabledDays);
  else if (disabledDays) result.push(disabledDays);

  return result;
};
